var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.96032H17C18.1046 2.96032 19 3.85575 19 4.96032V8.93651M5.5 2.96032H3C1.89543 2.96032 1 3.85575 1 4.96032V8.93651M5.5 2.96032V1M5.5 2.96032V4.92064M14.5 1V4.92064M1 8.93651V18C1 19.1046 1.89543 20 3 20H17C18.1046 20 19 19.1046 19 18V8.93651M1 8.93651H19M10 1V4.92064",
    stroke: "#F59D0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.c6e68486af56faa9c1f662b550d32f3a.svg";
export { ForwardRef as ReactComponent };